(function ($) {
    $.fn.extend({
    	sifVal: function (value) {
    		// Getter
    		if (typeof value === "undefined") {
    			var val = $(this).data("value") || $(this).val();
    			return val;
    		}
    		// Setter
    		else {
    			$(this).val(value);
    			$(this).data("value", value);
    			$(this).blur();
    			return this;
    		}
    	},
        setSifarnikValue: function (id, naziv) {
			$(this).val(id);
			$(this).data("value", id);
        	this.val(id + " - " + KUtils.htmlTagCharsDecode(naziv));
        },
    	kval: function (value) {
    	    var elem = this[0];
    	    var $el = $(elem);
    	    if (!arguments.length) {
    	       if (elem) {
                   if ($el.hasClass("bool-value")) {
						return  $el.val() == 'true' ? true : false;
                   }				   
                   else if ($el.hasClass("int-value")) {
					    if (elem.value == '') elem.value = 0;
                   		if ($el.hasClass('no-format'))
                   			return elem.value;
                   		else
                       		return KUtils.parseInt(elem.value);
                   }
                   else if ($el.hasClass("float-value")) {
				       //ovdje ne treba decimal kao drugi argument jer vrati vrijednost iz polja (s dobrim brojem decimala ako je na polju zadano)
				       if (elem.value == '') elem.value = 0;
                       return KUtils.parseFloat(elem.value);
                   }
                   else if ($el.parent().hasClass("sifarnik-group")) {
                       return $el.sifVal();
                   }
                   else if ($el.hasClass("konto-input-datetime")) {
                       var dtp = $el.data("kendoDateTimePicker");
                       if (typeof dtp !== "undefined" && dtp !== null) {
                           return dtp.value();
                       }
                   }
                   else if ($el.hasClass("konto-input-datetime-ss")) {
                       var dtp = $el.data("kendoDateTimePicker");
                       if (typeof dtp !== "undefined" && dtp !== null) {
                           return dtp.value();
                       }
                   }
                   else if ($el.hasClass("konto-input-date")) {
                       var dp = $el.data("kendoDatePicker");
                       if (typeof dp !== "undefined" && dp !== null) {
                           return dp.value();
                       }
                   }
                   else if ($el.hasClass("konto-input-year")) {
                       var dp = $el.data("kendoDatePicker");
                       if (typeof dp !== "undefined" && dp !== null) {
                           return dp.value();
                       }
                   }
                   else if ($el.hasClass("konto-dropdownlist")) {
                       var cmb = $el.data("kendoDropDownList");
                       if (typeof cmb !== "undefined" && cmb !== null) {
                           return cmb.value();
                       }
                   }
                   else {
                       return $el.val();
                   }
        	   }
    	       return;
    	    }

    	    return this.each(function () {
				if ($el.hasClass("bool-value")) {
					this.value =  value ? 'true' : 'false';
                }
    	        else if ($el.hasClass("int-value")) {
    	            // Što s NaN?
    	            if (!$el.hasClass('no-format'))
                    	this.value = KUtils.formatInt(value);
                    else
                    	this.value = value;
                }
                else if ($el.hasClass("float-value")) {
                    // Što s NaN?
                    var decimals = $el.data("decimals") || 2;
                    this.value = KUtils.formatFloat(value, decimals);
                }
                else if ($el.parent().hasClass("sifarnik-group")) {
                    $el.sifVal(value);
                }
                else if ($el.hasClass("konto-input-year")) {
                    var dtp = $el.data("kendoDatePicker");
                    if (typeof dtp !== "undefined" && dtp !== null) {
                        dtp.value(value);
                    }
                }
                else if ($el.hasClass("konto-input-datetime")) {
                    var dtp = $el.data("kendoDateTimePicker");
                    if (typeof dtp !== "undefined" && dtp !== null) {
                        dtp.value(value);
                    }
                }
                else if ($el.hasClass("konto-input-datetime-ss")) {
                    var dtp = $el.data("kendoDateTimePicker");
                    if (typeof dtp !== "undefined" && dtp !== null) {
                        dtp.value(value);
                    }
                }
                else if ($el.hasClass("konto-input-date")) {
                    var dp = $el.data("kendoDatePicker");
                    if (typeof dp !== "undefined" && dp !== null) {
                        dp.value(value);
                    }
                }
                else if ($el.hasClass("konto-input-year")) {
                    var dp = $el.data("kendoDatePicker");
                    if (typeof dp !== "undefined" && dp !== null) {
                        dp.value(value);
                    }
                }
                else if ($el.hasClass("konto-dropdownlist")) {
                    var cmb = $el.data("kendoDropDownList");
                    if (typeof cmb !== "undefined" && cmb !== null) {
                        cmb.value(value);
                    }
                }
                else {
                    this.value = value;
                }
    	    });
    	},
    	isKontoChecked: function () {
			var cbi = $(this).find('[type=checkbox]').first();
			if (cbi.prop("checked")) {
				return true;
			}
			else {
				return false;
			}
        },
        setKontoChecked: function(flag){
        	if (typeof flag == 'undefined')
				flag = true;
			var cbi = $(this).find('[type=checkbox]').first();
			cbi.prop("checked", flag);
        },
		isKontoReadonly: function () {
	    	var el = $(this);
	    	if (el.prop("readonly") ||
	    		el.prop("disabled") ||
	    		el.hasClass("konto-readonly")) {
	    			return true;
	    	}
	    	else {
	    		return false;
	    	}
		},
		setVisible: function(flag){
        	if (typeof flag == 'undefined')
				flag = true;

			if (flag){
				$(this).removeClass('hide');
			}else{
				$(this).addClass('hide');
			}
		},
		setEnabled: function(flag){
			if (typeof flag == 'undefined')
				flag = true;
			$(this).setKontoReadonly(!flag);
		},
		setBtnSucces: function(flag){
		    if (flag){
                $(this).removeClass('btn-light');
                $(this).addClass('btn-success');
		    }else{
                $(this).addClass('btn-light');
                $(this).removeClass('btn-success');
		    }
		},
    	setRequired: function (flag){
			if (typeof flag == 'undefined')
				flag = true;			
			var el = $(this);
			if (flag){
				el.prop("required", true);
	    		el.addClass("required-field"); 	
	    		var label = el.closest(".form-group").find("label").first();
	    		var oldText = label.text().trim();
	    		var lastChar = oldText.slice(-1);
	    		if(lastChar != "*"){
					label.text(oldText + "*");
				}			
			}
			else{
				el.prop("required", false);
	    		el.removeClass("required-field"); 	
	    		el.removeClass("border-danger");
	    		var label = el.closest(".form-group").find("label").first();
	    		var oldText = label.text().trim();
	    		var lastChar = oldText.slice(-1);
	    		if(lastChar == "*"){
					label.text(oldText.slice(0,oldText.length -1));
				}					
			}	
		},   		

		// dateTime mask: "00.00.0000 00:00:00"
		setKontoDateTime: function(dateTime) {
        	var el = $(this);

        	if(el.hasClass("konto-datetime-separate")){
        		var sDate = dateTime.substring(0, 10);
        		var sTime = dateTime.substring(11);
				var form = el.closest('.form-group');
	            var poljeDatum = form.find('input.konto-input-date-separate').first();
	            var poljeTime = form.find('input.konto-input-time-separate').first();
	            poljeDatum.val(sDate);
	            poljeTime.val(sTime);
	            el.val(dateTime);
			}
			else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
					el.val(dateTime);
			}
		},
		setKontoDate: function(sDate) {
        	var el = $(this);

        	if(el.hasClass("konto-datetime-separate")){
				var form = el.closest('.form-group');
	            var poljeDatum = form.find('input.konto-input-date-separate').first();
	            poljeDatum.val(sDate);
	            var old_val = el.val();
	            el.val(sDate + old_val.substring(10));
			}
			else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
					var sTime = el.val().substring(10);
					el.val(sDate + sTime);
			}
		},
		setKontoTime: function(sTime) {
        	var el = $(this);

        	if(el.hasClass("konto-datetime-separate")){
				var form = el.closest('.form-group');
	            var poljeTime = form.find('input.konto-input-time-separate').first();
	            poljeTime.val(sTime);
	            var old_val = el.val();
	            el.val(old_val.substring(0, 11) + sTime);
			}
			else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
					var sDate = el.val().substring(0,11);
					el.val(sDate + sTime);
			}
		},
		getKontoDateTime: function() {
        	var el = $(this);

        	if(el.hasClass("konto-datetime-separate")){
        		var form = el.closest('.form-group');
	            var poljeDatum = form.find('input.konto-input-date-separate').first();
	            var poljeTime = form.find('input.konto-input-time-separate').first();

	            return poljeDatum.val() + ' ' + poljeTime.val();
        	}
        	else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
				return el.val();
			}
        },
		getKontoDate: function() {
        	var el = $(this);

        	if(el.hasClass("konto-datetime-separate")){
        		var form = el.closest('.form-group');
	            var poljeDatum = form.find('input.konto-input-date-separate').first();

	            return poljeDatum.val();
        	}
        	else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
				return el.val().substring(0,10);
			}
        },
        getKontoTime: function() {
        	var el = $(this);

        	if(el.hasClass("konto-datetime-separate")){
        		var form = el.closest('.form-group');
	            var poljeTime = form.find('input.konto-input-time-separate').first();

	            return poljeTime.val();
        	}
        	else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
				return el.val().substring(11);
			}
        },
        setContainerReadonly: function(flag){
			var $cont = $(this);
			
			if (typeof flag == 'undefined')
				flag = true;

			var elemToSet = '.konto-radio, .konto-radio-extended, .konto-combobox, .combobox-group, .konto-checkbox-extended,' +
				'.konto-input-date, .konto-input-datetime, .konto-input-datetime-ss,' + 
				'.konto-input-time, .konto-input-time-ss, .konto-input-year, .konto-datetime-separate,' +
				'.konto-input, .sifarnik-group, .konto-button';			
			var $elements = $cont.find(elemToSet);
			
			$elements.each(function(){
				var el = $(this);
				el.setKontoReadonly(flag);
			});
        },
		setKontoReadonly: function (flag, flagt) {
        	var el = $(this);
			//Hidden polje - return
        	if (typeof flag == 'undefined')
				flag = true;

			//Radio butoni
			if (el.hasClass("konto-radio")) {
				el.setRadioButtonReadonly(flag);
			}
			if(el.hasClass("konto-radio-extended")) {
				var radio = el.find(".konto-radio").first();
				radio.setRadioButtonReadonly(flag);
			}

			//ComboBox
			if(el.hasClass("konto-combobox")) {
				el.setComboBoxReadonly(flag);
			}
			
			if (el.hasClass("combobox-group")){
				el.setComboBoxGroupReadonly(flag);
			}

			//Checkbox-extended
			if(el.hasClass("konto-checkbox-extended")) {
				el.setCheckBoxReadonly(flag);
			}

			//Checkbox
            if(el.hasClass("checkbox")) {
                el.setCheckBoxNormalReadonly(flag);
            }

			//Separate mora biti prije običnih date-time
			if(el.hasClass("konto-datetime-separate")){
				var form = el.closest('.form-group');
	            var poljeDatum = form.find('input.konto-input-date-separate').first();
	            var poljeTime = form.find('input.konto-input-time-separate').first();
	            poljeDatum.setDateTimeReadonly(flag);
	            if (typeof flagt == 'undefined'){
	            	flagt = flag;
	            }
	            poljeTime.setDateTimeReadonly(flagt);
			}
			//Date, DateTime, Time, DateTimeSS, TimeSS
			else if( (el.hasClass("konto-input-date")) || (el.hasClass("konto-input-datetime")) || (el.hasClass("konto-input-datetime-ss"))
					|| (el.hasClass("konto-input-time")) || (el.hasClass("konto-input-time-ss")) || (el.hasClass("konto-input-year")) ) {
					el.setDateTimeReadonly(flag);
			}

			//Obični text
			if(el.hasClass("konto-input")) {
				el.setInputReadonly(flag);
			}

			if(el.hasClass("konto-ispis-input")) {
				el.setIspisInputReadonly(flag);
			}			
			
			//Buttoni
			if(el.hasClass("konto-button")) {
				el.setButtonDisabled(flag);
			}
			
			//Šifarnik group
			if ( el.hasClass("sifarnik-group") || ( el.parent().hasClass("sifarnik-group") ) ) {
				el.setSifarnikReadonly(flag);
			}
        },
        setButtonDisabled: function(flag){
			var el = $(this);
			var form = el.closest('.form-group');
        	if (typeof flag == 'undefined')
				flag = true;
				
			el.prop('disabled', flag);
			if(flag){
				form.addClass("cursorNotAllowed");
				el.addClass("nonClickable");
				el.addClass("colorReadonly");
			}
			else{
				form.removeClass("cursorNotAllowed");
				el.removeClass("nonClickable");
				el.removeClass("colorReadonly");
			}
		}, 
        setDateTimeReadonly: function (flag) {
        	var datetime = $(this);
        	var form = datetime.closest('.form-group');
        	var chale = datetime.closest('span.k-widget');

        	if (typeof flag == 'undefined')
				flag = true;

        	if(datetime.hasClass("konto-datetime-separate")) {
        		var date_separate = chale.find('.konto-input-date-separate').first();
        		var time_separate = chale.find('.konto-input-time-separate').first();

	        	if(flag) {
					form.addClass("cursorNotAllowed");
					date_separate.addClass("konto-readonly");
					date_separate.addClass("date-readonly");
					date_separate.addClass("nonClickable");
					date_separate.prop("readonly", true);
					date_separate.addClass("colorReadonly");
					time_separate.addClass("konto-readonly");
					time_separate.addClass("date-readonly");
					time_separate.addClass("nonClickable");
					time_separate.prop("readonly", true);
					time_separate.addClass("colorReadonly");
	        	}
	        	else {
					form.removeClass("cursorNotAllowed");
					date_separate.removeClass("konto-readonly");
					date_separate.removeClass("date-readonly");
					date_separate.removeClass("nonClickable");
					date_separate.prop("readonly", false);
					date_separate.removeClass("colorReadonly");
					time_separate.removeClass("konto-readonly");
					time_separate.removeClass("date-readonly");
					time_separate.removeClass("nonClickable");
					time_separate.prop("readonly", true);
					time_separate.removeClass("colorReadonly");
	        	}
        	}
        	else {
	        	if(flag) {
					form.addClass("cursorNotAllowed");
					datetime.addClass("konto-readonly");
					chale.addClass("date-readonly");
					chale.addClass("nonClickable");
					datetime.prop("readonly", true);
	        	}
	        	else {
					form.removeClass("cursorNotAllowed");
					datetime.removeClass("konto-readonly");
					chale.removeClass("date-readonly");
					chale.removeClass("nonClickable");
					datetime.prop("readonly", false);
	        	}
        	}
		},
        setComboBoxReadonly: function (flag) {
        	var kendoEl = $(this);
        	var formGrup = kendoEl.closest('.form-group');
        	var span = kendoEl.closest('span.k-widget');
        	
        	if (span.length == 0){ //ovo je slučaj za formParam-combobox-group
				var span = kendoEl.find('span.k-widget');	
			}
        	
        	if (typeof flag == 'undefined')
				flag = true;

        	if(flag) {
				formGrup.addClass("cursorNotAllowed");
				span.addClass("konto-readonly");
				span.addClass("combo-readonly");
				span.addClass("nonClickable");
				span.prop("readonly", true);
				span.children().find(':input').addClass("skipEnterTab");
        	}
        	else {
				formGrup.removeClass("cursorNotAllowed");
				span.removeClass("konto-readonly");
				span.removeClass("combo-readonly");
				span.removeClass("nonClickable");
				span.prop("readonly", false);
				span.children().find(':input').removeClass("skipEnterTab");
        	}

        },
        setComboBoxGroupReadonly: function(flag){
	        if (typeof flag == 'undefined')
				flag = true;
        	var kendoEl = $(this);
        	var formGrup = kendoEl.closest('.form-group');
        	var span = kendoEl.find('span.k-widget');

        	if(flag) {
				formGrup.addClass("cursorNotAllowed");
				span.addClass("konto-readonly");
				span.addClass("combo-readonly");
				span.addClass("nonClickable");
				span.prop("readonly", true);
				span.children().find(':input').addClass("skipEnterTab");
        	}
        	else {
				formGrup.removeClass("cursorNotAllowed");
				span.removeClass("konto-readonly");
				span.removeClass("combo-readonly");
				span.removeClass("nonClickable");
				span.prop("readonly", false);
				span.children().find(':input').removeClass("skipEnterTab");
        	}
		},
		setRadioButtonReadonly: function (flag) {
        	var radio = $(this);

        	if (typeof flag == 'undefined')
				flag = true;

        	if(flag) {
        		radio.prop("readonly", true);
				radio.addClass("konto-readonly");
				radio.addClass("cursorNotAllowed");
				radio.addClass("colorReadonly");

				radio.find("input[type=radio]")
					.each(function(){
	        			if (!($(this).is(":checked")))
	        				$(this).attr("disabled", true);
	        			else
	        				$(this).addClass('konto-readonly');
	        		});

				radio.find("*").filter(":visible")
					.each(function(){
	        			$(this).addClass("nonClickable");
	    			});
        	}
        	else {
        		radio.prop("readonly", false);
				radio.removeClass("konto-readonly");
				radio.removeClass("colorReadonly");
	        	radio.removeClass("cursorNotAllowed");

				radio.find("*")
					.each(function(){
        				$(this).attr("disabled", false);
	        			$(this).removeClass("nonClickable");
	    			});
        	}
		},
		setCheckBoxReadonly: function (flag) {
			var cb = $(this);
			var cbl = cb.find('.konto-checkbox-main-label').first();
			var cbli = cb.find('.konto-checkbox-label').first();
			var cbi = cb.find('[type=checkbox]').first();
			var chale = cb.parent();
			var _border = false;
			if (typeof cb.data('border') != 'undefined') {
				_border = cb.data('border');
			}

        	if (typeof flag == 'undefined')
				flag = true;

        	var _readonly_color = false;
			if (typeof cb.data('readonly-color') != 'undefined') {
				_readonly_color = cb.data('readonly-color');
			}

        	if(flag) {
        			cb.addClass("konto-readonly");
        			cb.addClass("cursorNotAllowed");
        			cb.find("*").addClass("konto-readonly");
        			cb.find("*").addClass("cursorNotAllowed");

					if(_readonly_color) {
						cbl.addClass('colorReadonly checkBoxLeftPadding height100');
					}
					else {
						if(!($.styleSheetExist('.uskiCSS'))){
							cbli.addClass('checkBoxTopPaddingLabelFix');
						}
						if (_border){
							cbl.removeClass('form-control');
							cbl.addClass('checkBoxFormControl');
						}
					}

					cbli.addClass('textColorReadonly');
                    cbi.addClass('textColorReadonly');
					cbi.prop("readonly", true);
					cbi.prop("disabled", true);
					cbi.addClass('nonClickable');
        	}
        	else {
        			cb.removeClass("konto-readonly");
        			cb.removeClass("cursorNotAllowed");
        			cb.find("*").removeClass("konto-readonly");
        			cb.find("*").removeClass("cursorNotAllowed");

					if(_readonly_color) {
						cbl.removeClass('colorReadonly checkBoxLeftPadding height100');
					}
					else {
						if(!($.styleSheetExist('.uskiCSS'))){
							cbli.addClass('checkBoxTopPaddingLabelFix');
						}
						if (_border){
							cbl.addClass('form-control');
							cbl.removeClass('checkBoxFormControl');
						}
					}

					cbli.removeClass('textColorReadonly');
                    cbi.removeClass('textColorReadonly');
					cbi.prop("readonly", false);
					cbi.prop("disabled", false);
					cbi.removeClass('nonClickable');
        	}
		},
		setCheckBoxNormalReadonly: function (flag) {
            var cb = $(this);
            var cbi = cb.find('[type=checkbox]').first();
            if (typeof flag == 'undefined')flag = true;
		    if(flag) {
                cb.addClass("konto-readonly");
                cb.addClass("cursorNotAllowed");
                cb.addClass('colorReadonly');
                cb.prop("readonly", true);
                cb.addClass('nonClickable');
                cb.find("*").addClass("konto-readonly");
                cb.find("*").addClass("cursorNotAllowed");                

                cbi.addClass('colorReadonly');
                cbi.prop("readonly", true);
                cbi.addClass('nonClickable');
		    }else{
                cb.removeClass("konto-readonly");
                cb.removeClass("cursorNotAllowed");
                cb.removeClass('colorReadonly');
                cb.prop("readonly", false);
                cb.removeClass('nonClickable');
                cb.find("*").removeClass("konto-readonly");
                cb.find("*").removeClass("cursorNotAllowed");

                cbi.removeClass('colorReadonly');
                cbi.prop("readonly", false);
                cbi.removeClass('nonClickable');
		    }
		},
		setInputReadonly: function (flag) {
			var input = $(this);
			var chale = input.parent();
        	if (typeof flag == 'undefined')
				flag = true;
			if(flag) {
				input.addClass('nonClickable');
				input.addClass('colorReadonly');
				chale.addClass("cursorNotAllowed");
				input.addClass("konto-readonly");
				input.prop("readonly", true);
			}
			else {
				input.removeClass('nonClickable');
				input.removeClass('colorReadonly');
				chale.removeClass("cursorNotAllowed");
				input.removeClass("konto-readonly");
				input.prop("readonly", false);
			}
		},
		setIspisInputReadonly: function (flag) {
			var input = $(this);
			var chale = input.parent();
			var inputfields = input.find("input");
			var ul = input.find("ul");			
        	if (typeof flag == 'undefined')
				flag = true;
			if(flag) {
				input.addClass('nonClickable');
				inputfields.addClass('colorReadonly');
				ul.addClass('colorReadonly');				
				chale.addClass("cursorNotAllowed");
				input.addClass("konto-readonly");
				input.prop("readonly", true);
			}
			else {
				input.removeClass('nonClickable');
				inputfields.removeClass('colorReadonly');
				ul.removeClass('colorReadonly');				
				chale.removeClass("cursorNotAllowed");
				input.removeClass("konto-readonly");
				input.prop("readonly", false);
			}
		},		
		setSifarnikReadonly: function (flag) {
			var sifarnik = $(this);
			var chale = sifarnik.parent();
			var input = sifarnik.find("input").first();
			var span = sifarnik.find(".sifarnik-button").first();
			var areq = input.attr("required");
			
        	if (typeof flag == 'undefined')
				flag = true;
			if(flag) {		
				sifarnik.addClass('nonClickable');
				input.addClass('colorReadonly');
				input.addClass("konto-readonly");
				input.prop("readonly", true);
				span.addClass('colorReadonly');
				chale.addClass("cursorNotAllowed");
				sifarnik.addClass("konto-readonly");
				sifarnik.prop("readonly", true);
				if(typeof areq !== typeof undefined && areq !== false) {			
					input.removeClass("border-danger");
					input.removeClass("required-field");
				}					
			}
			else {			
				sifarnik.removeClass('nonClickable');
				input.removeClass('colorReadonly');
				input.removeClass("konto-readonly");
				input.prop("readonly", false);
				span.removeClass('colorReadonly');
				chale.removeClass("cursorNotAllowed");
				sifarnik.removeClass("konto-readonly");
				sifarnik.prop("readonly", false);
				if(typeof areq !== typeof undefined && areq !== false) {
					input.addClass("required-field");
				}					
			}
		},
		setKontoMoreText: function(obavijest){
			var more = $(this);
        	if (typeof obavijest == 'undefined')
				obavijest = '';

        	more.data("obavijest",obavijest);
        	more.trigger("change");
        },
        setEqualHeight: function(){
		    var maxHeight = 0;
		    this.each(function(){
		        if( $(this).height() > maxHeight ){maxHeight = $(this).height();}
		    });
		    return this.each(function(){
		        $(this).height(maxHeight);
			});
        },
        setEqualWidth: function(){
		    var maxWidth = 0;
		    this.each(function(){
		        if( $(this).width() > maxWidth ){maxWidth = $(this).width();}
		    });
		    return this.each(function(){
		        $(this).width(maxWidth);
			});
        },

        textWidth:function(){
             var calc = '<span style="display:none">' + $(this).text() + '</span>';
             $('body').append(calc);
             var width = $('body').find('span:last').width();
             $('body').find('span:last').remove();
            return width;
        },

        setBtnSuccess: function(flag){
            if (typeof flag == 'undefined')
                flag = true;

            if (flag){
                $(this).addClass('btn-success');
                $(this).removeClass('btn-light');
            }else{
                $(this).addClass('btn-light');
                $(this).removeClass('btn-success');
            }
        },

        marquee: function(args) {
            var that = $(this);
            var textWidth = that.textWidth(),
                offset = that.width(),
                width = offset,
                css = {
                    'text-indent' : that.css('text-indent'),
                    'overflow' : that.css('overflow'),
                    'white-space' : that.css('white-space')
                },
                marqueeCss = {
                    'text-indent' : width,
                    'overflow' : 'hidden',
                    'white-space' : 'nowrap'
                },
                args = $.extend(true, { count: -1, speed: 10, leftToRight: false }, args),
                i = 0,
                stop = textWidth*-1,
                dfd = $.Deferred();

             that.mouseenter(function(){
             	$(this).data('stop', true);
             });

             that.mouseleave(function(){
             	$(this).data('stop', false);
             	go();
             });

            function go() {
                if(!that.length) return dfd.reject();
                if(width == stop) {
                    i++;
                    if(i == args.count) {
                        that.css(css);
                        return dfd.resolve();
                    }
                    if(args.leftToRight) {
                        width = textWidth*-1;
                    } else {
                        width = offset;
                    }
                }
                that.css('text-indent', width + 'px');
                if(args.leftToRight) {
                    width++;
                } else {
                    width--;
                }
                if (! $(that).data('stop'))
                	setTimeout(go, args.speed);
            };

            if(args.leftToRight) {
                width = textWidth*-1;
                width++;
                stop = offset;
            } else {
                width--;
            }
            that.css(marqueeCss);
            go();
            return dfd.promise();
        },

    });

    /**
     * Extendanje $.valHooks je isprobano. Ideja je bila da se vrati točno onaj podatak koji želimo - integer, float, date itd.
     * Problem je primjerice da $("form").serializeArray() funkcija koristi val() i zahtijeva da vrijednosti budu string.
     * Razlog tome je što se radi str.replace() nad dobivenim vrijednostima.
     *
     * TODO: Eventualna primjena bi mogla biti za elemente šifarnika tako da se izbjegna jQuery serijalizacija.
     */

    /**
     * Kao "rješenje" gore opisanog problema napravljena je funkcija kval koja daje točne vrijednosti, a val ostaje netaknuta.
     */
    /*
    $.extend(true, $.valHooks, {
        input: {
            get: function (elem) {
                var $el = $(elem);
                if ($el.hasClass("int-value")) {
                    return "" + KUtils.parseInt(elem.value);
                }
                else if ($el.hasClass("float-value")) {
                    return "" + KUtils.parseFloat(elem.value);
                }
                return undefined;
            },
            set: function (elem, value) {
                var $el = $(elem);
                if ($el.hasClass("int-value")) {
                    var str = "";
                    if (KUtils.isInteger(value)) {
                        str = KUtils.formatInt(parseInt(value));
                    }
                    elem.value = str;
                    return $el;
                }
                else if ($el.hasClass("float-value")) {
                    var str = "";
                    if (KUtils.isNumber(value)) {
                        str = KUtils.formatFloat(parseFloat(value), $el.data("decimals"));
                    }
                    elem.value = str;
                    return $el;
                }
                return undefined;
            }
        }
    });
    */
} (jQuery));
